import * as React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import Loading from 'modules/layout/components/Page/Loading'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import { usePolicies } from 'modules/payroll_bundle/store/collections/policies'
import PolicyPeriod from 'modules/payroll_bundle/store/models/PolicyPeriod'

type LocationState = {
  policyPeriodId: string
  employeeId: string
}

const RedirectSupplementsPage = () => {
  const policies = usePolicies()
  const { navigation } = useNavigation()
  const { loadingPolicyPeriodCollection, policyPeriodCollection, policyId, setCurrentPolicy } =
    usePolicyPeriods()
  const locationStateRef = React.useRef<LocationState | null>(useLocation().state)
  let currentPolicyPeriod: PolicyPeriod | undefined

  if (!loadingPolicyPeriodCollection && locationStateRef.current) {
    const policyPeriodId = locationStateRef.current.policyPeriodId
    if (policyPeriodId) {
      currentPolicyPeriod = policyPeriodCollection.get(policyPeriodId)
    } else {
      const defaultPeriodId = PolicyPeriod.findCurrentOrLatestPeriodIndex(
        policyPeriodCollection.models
      )
      currentPolicyPeriod = policyPeriodCollection.get(defaultPeriodId)
    }
  }

  const { loading } = useAsyncData(() => policies.fetch(), [])

  if (loading || loadingPolicyPeriodCollection) return <Loading />

  const buildPath = () => {
    const basePolicyPath = navigation.payrollBundle.policy
    if (currentPolicyPeriod) {
      setCurrentPolicy(currentPolicyPeriod.attributes.policy_id, currentPolicyPeriod.id)
      return basePolicyPath.period.cycles.supplements.fullPath({
        policyId: currentPolicyPeriod.attributes.policy_id,
        periodId: currentPolicyPeriod.id,
      })
    }

    if (policyId) {
      return basePolicyPath.fullPath({ policyId: policyId })
    }

    if (policies.length > 0) {
      const defaultPolicy = policies.find({ default: true })
      return defaultPolicy
        ? basePolicyPath.fullPath({ policyId: defaultPolicy.id.toString() })
        : navigation.payrollBundle.fullPath()
    }

    return navigation.payrollBundle.fullPath()
  }

  return <Navigate to={buildPath()} state={locationStateRef.current}></Navigate>
}

export default RedirectSupplementsPage
